import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import homebackgroundimg from './../image/Career_banner.mp4';

import { Helmet } from 'react-helmet';
const faqsData = [
  {
    question: "What is a Nexify consultant?",
    answer: "Nexify consultants are employees hired to work on projects for our clients."
  },
  {
    question: "How can Nexify help me find a job?",
    answer: "We match you with opportunities in various roles, including direct placement, contract-to-hire, and contract jobs, based on your experience and preferences."
  },
  {
    question: "What industries and companies does Nexify work with?",
    answer: "We work with companies across multiple industries such as technology, healthcare, finance, retail, and more."
  },
  {
    question: "What kinds of jobs does Nexify specialize in?",
    answer: "We specialize in IT-related roles, including application management, engineering, digital experience, security, and more."
  },
  {
    question: "How do I get started with the recruiting process?",
    answer: "Connect with a local recruiter to discuss your job preferences and apply for positions through Nexify."
  },
  {
    question: "Do I have to pay for Nexify recruiting services?",
    answer: "No, our recruiting services are completely free for job seekers."
  },
  {
    question: "Where are you located, and can Nexify help me find local, state-specific, or remote jobs?",
    answer: "Nexify has offices in India, Abu Dhabi, and the United States. We can help you find local, state-specific, or remote job opportunities. To view our office locations and current job openings, visit our <Link to='/contact'>contact page</Link> or check out the <Link to='/job-search'>current openings</Link>."
  }
];
const ConsultantCareer = ({ title }) => {
  const [filters, setFilters] = useState({
    searchQuery: '',
    location: '',
  });
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full h-auto bg-white flex flex-col items-center justify-center lg:mt-20 sm:mt-0">
      <Helmet>
        <title>Consultant Career - Nexify Infosystems</title>
        <meta name="description" content="Explore career opportunities with Nexify Infosystems, providing exceptional benefits, consultant care, and valuable career resources." />
        <meta name="keywords" content="Consultant Career, Nexify Infosystems, IT Professionals, Career Opportunities, Consultant Care, Benefits, FAQs" />
      </Helmet>
      <div className="w-full h-[440px] relative flex items-center justify-center">
        {/* Video Background */}
        <video
          className="absolute top-0 left-0 w-full h-full object-cover"
          src={homebackgroundimg}
          autoPlay
          loop
          muted
        />

        {/* Content */}
        <div className="relative z-10 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
          <div
            className="opacity-0 translate-y-10 animate-slideUp bg-[#0c5495b3] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[80%] lg:ml-14 border border-white/20 rounded-lg relative"
            style={{
              animation: "slideUp 1s ease-in-out forwards",
              animationDelay: "2s",
            }}
          >
            <h1 className="text-[8vw] md:text-[55px] font-semibold mb-2 break-words bg-gradient-to-r from-[#ffffff] to-[#39a0ff] text-transparent bg-clip-text relative z-10">
              Empowering IT Careers Across the Globe
            </h1>
          </div>
        </div>
      </div>
      {/* Pass filters and handleInputChange to SearchBar */}
      <div className="w-full max-w-[1320px] px-4 mx-auto mt-5 mb-5">
        <div className="bg-white flex flex-col md:flex-row p-6 w-full max-w-[1320px] gap-10 mb-4 mt-4">
          <div className="flex-1">
            <p className="text-[#6d6d70] leading-[1.8] font-[400]  text-[16px]  lg:text-justify text-left">
              At Nexify Infosystems, we are committed to connecting highly-skilled IT professionals with outstanding career opportunities worldwide. With a presence in India, Abu Dhabi, and the United States, we offer a personalized approach to help talent grow and succeed in diverse industries. Our team is dedicated to providing exceptional support, a competitive benefits package, and access to top-tier job prospects, ensuring that each individual’s career journey is fulfilling and rewarding.
            </p>
          </div>
        </div>

        <div className="bg-white flex flex-col md:flex-row p-6 w-full max-w-[1320px]">
          <div className="flex-1">
            <h2 className='lg:text-[40px] text-[30px] font-[700] text-[#0e55a8] '>Comprehensive Benefits for Your Health, Future, and Career Growth</h2>
            <p className="text-[#6d6d70] font-[400] text-[16px] leading-[1.8] mb-4 lg:text-justify text-left">
              At Nexify Infosystems, we prioritize your well-being and future. Our extensive benefits package includes Health, Vision, Dental, and Life Insurance, ensuring that you and your loved ones are well-covered. Additionally, we provide robust Disability Coverage, including Short-Term and Long-Term Disability, as well as Critical Illness and Accident Insurance, so you’re protected when life’s unexpected challenges arise.</p>
            <p className="text-[#6d6d70] font-[400] text-[16px] leading-[1.8] lg:text-justify text-left">Beyond insurance, we are committed to your professional growth and personal enrichment. Our Career Training programs, Toolbox Talks with industry experts, and access to exclusive training resources will help propel your career forward. We also offer a variety of lifestyle discounts and perks on travel, retail, and more, as well as a Referral Bonus program, allowing you to earn money for helping us find top talent. Once enrolled, all benefits details are available 24/7 via BenefitSolver, providing you easy access whenever needed.</p>
          </div>
        </div>

        <div className="bg-white flex flex-col md:flex-row p-6 w-full max-w-[1320px]">
          <div className="flex-1">
            <h2 className='lg:text-[40px] text-[30px] font-[700] text-[#0e55a8] '>Consultant Care: Supporting Your Career Every Step of the Way</h2>
            <p className="text-[#6d6d70] font-[400] text-[16px] leading-[1.8] mb-4 lg:text-justify text-left">
              At Nexify Infosystems, we prioritize your success by providing continuous support and career opportunities nationwide. Our Consultant Relationship Coordinators ensure clear communication, satisfaction, and timely updates, while our Consultant Care Centre offers assistance with benefits, time management, and personal updates. We foster long-term relationships through goal setting, career development, and regular check-ins to ensure your progress.</p>
            <p className="text-[#6d6d70] font-[400] text-[16px] leading-[1.8] lg:text-justify text-left">Beyond assignments, we offer Transition Coaching to help with career planning, networking, and skills development, as well as an Alumni Program to keep you engaged with job notifications and professional resources. Through community engagement and ongoing support, Nexify is committed to your growth and success, even after your assignment ends.</p>
          </div>
        </div>

        <div className="space-y-0">
  {faqsData.map((faq, index) => (
    <div
      key={index}
      className={`border w-full overflow-hidden transition-all ${
        openIndex === index ? "shadow-none border-none" : "shadow-md border"
      }`}
    >
      <button
        className={`flex justify-between items-start w-full text-left md:p-7 p-3 transition-all ${
          openIndex === index ? "bg-[#efefef]" : "bg-[#efefef] hover:bg-gray-300"
        } focus:outline-none`}
        onClick={() => toggleAnswer(index)}
      >
        <h3 className="font-[500] lg:text-[18px] text-[14px] flex-1">{faq.question}</h3>

        {/* Rounded Button with Border - Positioned Properly */}
        <span
          className={`lg:w-7 lg:h-7 w-5 h-5 flex items-center justify-center lg:text-[18px] text-[14px] font-bold rounded-full border-2 transition-all 
            ${openIndex === index ? "border-red-500 text-red-500" : "border-blue-500 text-blue-500"} self-start ml-2`}
        >
          {openIndex === index ? "×" : "+"}
        </span>
      </button>

      {/* Expanded Answer Section */}
      <div className={`transition-all duration-300 ${openIndex === index ? "p-4" : "hidden"}`}>
        {Array.isArray(faq.answer) ? (
          <>
            <p className="text-[#6d6d70] lg:text-[16px] text-[14px]">{faq.answer[0]}</p>
            <ul className="list-disc pl-5 text-[#363638] text-[18px] mt-2">
              {faq.answer[1].map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </>
        ) : (
          <p className="text-[#6d6d70] leading-[1.8] font-[400] text-[16px]">{faq.answer}</p>
        )}
      </div>
    </div>
  ))}
</div>

        <div className="flex mt-20 mb-10">
          <Link
            to="/job-search"
            className="bg-[#fb9d3d] hover:bg-[#ffac43] text-white text-[18px] uppercase font-semibold py-3 px-6 shadow-lg transition-all duration-300"
          >
            View Our Open Positions
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ConsultantCareer;
